/**
 * Module-singleton pending upload store.
 * Survives client-side navigation (SPA transitions) but not full page reloads.
 * Used to carry a File from the upload/dialog pages to the /workbooks/import
 * header-configurator page without serialising through sessionStorage.
 */

type Pending = { file: File };

let pending: Pending | null = null;

export function setPendingUpload(p: Pending): void {
  pending = p;
}

/** Take-and-clear — the import page calls this on mount. */
export function takePendingUpload(): Pending | null {
  const p = pending;
  pending = null;
  return p;
}

/** Peek without clearing — use for guards / redirects. */
export function peekPendingUpload(): Pending | null {
  return pending;
}
